import { render, staticRenderFns } from "./B-1-2-3_HomePageEdit_BU_Sections.vue?vue&type=template&id=439fae9e&"
import script from "./B-1-2-3_HomePageEdit_BU_Sections.vue?vue&type=script&lang=js&"
export * from "./B-1-2-3_HomePageEdit_BU_Sections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VIcon,VSpacer,VTextField,VTextarea})
